import { VariablesOf } from '@graphql-typed-document-node/core';
import { queryOptions } from '@tanstack/react-query';

import { datoRequester } from 'queries/requesters';
import {
  LineupEntriesDocument,
  LineupEntryDocument,
  LineupsDocument,
  LineupSelectionDocument,
  LineupXpArtistDocument,
  LineupXpArtistsDocument,
  LineupXpPartnersDocument,
  LineupXpSessionDocument,
  LineupXpSessionsDocument,
  LineupXpSpeakerDocument,
  LineupXpSpeakersDocument,
} from 'types/api/dato-operations.types';

const LINEUP_PREFIX = 'lineup';

export const lineupsQuery = (variables: VariablesOf<typeof LineupsDocument>) =>
  queryOptions({
    queryKey: [LINEUP_PREFIX, variables],
    queryFn: datoRequester(LineupsDocument, variables),
  });

export const lineupSelectionQuery = (
  variables: VariablesOf<typeof LineupSelectionDocument>,
) =>
  queryOptions({
    queryKey: [LINEUP_PREFIX, 'selection', variables],
    queryFn: datoRequester(LineupSelectionDocument, variables),
  });

export const lineupEntriesQuery = (
  variables: VariablesOf<typeof LineupEntriesDocument>,
) =>
  queryOptions({
    queryKey: [LINEUP_PREFIX, 'entries', variables],
    queryFn: datoRequester(LineupEntriesDocument, variables),
  });

export const lineupEntryQuery = (
  variables: VariablesOf<typeof LineupEntryDocument>,
) =>
  queryOptions({
    queryKey: [LINEUP_PREFIX, 'entry', variables],
    queryFn: datoRequester(LineupEntryDocument, variables),
  });

export const lineupXpSessionsQuery = (
  variables: VariablesOf<typeof LineupXpSessionsDocument>,
) =>
  queryOptions({
    queryKey: [LINEUP_PREFIX, 'xp', 'sessions', variables],
    queryFn: datoRequester(LineupXpSessionsDocument, variables),
  });

export const lineupXpSpeakersQuery = (
  variables: VariablesOf<typeof LineupXpSpeakersDocument>,
) =>
  queryOptions({
    queryKey: [LINEUP_PREFIX, 'xp', 'speakers', variables],
    queryFn: datoRequester(LineupXpSpeakersDocument, variables),
  });

export const lineupXpArtistQuery = (
  variables: VariablesOf<typeof LineupXpArtistDocument>,
) =>
  queryOptions({
    queryKey: [LINEUP_PREFIX, 'xp', 'artist', variables],
    queryFn: datoRequester(LineupXpArtistDocument, variables),
  });

export const lineupXpArtistsQuery = (
  variables: VariablesOf<typeof LineupXpArtistsDocument>,
) =>
  queryOptions({
    queryKey: [LINEUP_PREFIX, 'xp', 'artists', variables],
    queryFn: datoRequester(LineupXpArtistsDocument, variables),
  });

export const lineupXpSessionQuery = (
  variables: VariablesOf<typeof LineupXpSessionDocument>,
) =>
  queryOptions({
    queryKey: [LINEUP_PREFIX, 'xp', 'session', variables],
    queryFn: datoRequester(LineupXpSessionDocument, variables),
  });

export const lineupXpSpeakerQuery = (
  variables: VariablesOf<typeof LineupXpSpeakerDocument>,
) =>
  queryOptions({
    queryKey: [LINEUP_PREFIX, 'xp', 'speaker', variables],
    queryFn: datoRequester(LineupXpSpeakerDocument, variables),
  });

export const lineupXpPartnersQuery = (
  variables: VariablesOf<typeof LineupXpPartnersDocument>,
) =>
  queryOptions({
    queryKey: [LINEUP_PREFIX, 'xp', 'partners', variables],
    queryFn: datoRequester(LineupXpPartnersDocument, variables),
  });
